import { Component } from '@angular/core';
import { AccountState } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { AccountInfoType } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-add-beneficiary',
  templateUrl: './add-beneficiary.component.html',
  styleUrls: ['./add-beneficiary.component.scss'],
})
export class AddBeneficiaryComponent {
  selectedAccount: AccountInfoType | undefined;

  constructor(private store: Store) {
    this.selectedAccount = this.store.selectSnapshot(AccountState.getCurrentAccount);
  }
}
